import { containerWashPlanService } from "@/app/plans/containerWash/services/containerWash.plan.service"


const initPlanData = {
  type: 'containerWash',
  name: null,
  device_id: null,
  camp_id:null,
  camp_leave: null,
  camp_back: null,
  route: null,
  times:null,
  schedule:null,
  days:[],
  containers_count:null,
  containers_excl_file:null,
}

const initialState = () => {
  return {
    loading: false,
    errors: {},
    data: Object.assign({}, initPlanData)
  }
}

const state = initialState()

const mutations = {

  RESET_STORE_DATA(state) {
    Object.assign(state, { ...initialState() })
  },

  REQUEST_SEND(state) {

    Object.assign(state, {
      loading: true,
      errors: {}
    })
  },

  REQUEST_FINISHED(state) {
    Object.assign(state, {
      loading: false,
    })
  },

  SET_PLAN_DATA(state, data) {
 
    Object.assign(state.data, {
        ...data,
        route:data.data.route,
        schedule:data.data.schedule,
        times:data.data.times,
        days:data.data.days,
        containers_count:data.data.count
    })

    delete state.data.data

  },

  REQUEST_SUCCESS(state) {
    Object.assign(state, {
      data: Object.assign({}, initPlanData),
      errors: {},
      loading: false
    })
  },

  REQUEST_ERROR(state, error) {
    Object.assign(state, {
      errors: error,
      loading: false
    })
  },

}


const actions = {

  createPlan(context) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(context.state.data)) {
      if ((key === 'days' && value !== null)) {
        value.forEach(item => formData.append(`${key}[]`, item));
      }else if(value !== null) {
        formData.append(key, value)
      }
    }
    
    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      containerWashPlanService.createPlan(formData).then(res => {
        context.commit('REQUEST_SUCCESS')
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },


  updatePlan(context, id) {

    const formData = new FormData();
    formData.append("id", id)
    for (const [key, value] of Object.entries(context.state.data)) {
      if ((key === 'days' && value !== null)) {
        value.forEach(item => formData.append(`${key}[]`, item));
      }else if(value !== null) {
        formData.append(key, value)
      }
    }
    
    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      containerWashPlanService.updatePlan(id, formData).then(res => {
        context.commit('REQUEST_FINISHED')
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },

  getPlan(context, id) {
    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      containerWashPlanService.getPlanById(id).then(res => {
        context.commit('REQUEST_SUCCESS')
        context.commit('SET_PLAN_DATA', res)
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },

  deletePlan(context, id, PlanType) {
    return new Promise((resolve, reject) => {
      containerWashPlanService.deletePlan(id, PlanType).then(res => resolve(res))
        .catch(reason => reject(reason))
    })
  },

}




export default {
  namespaced: true,
  state,
  mutations,
  actions
};
